import { useState } from 'react';

import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import { UpdatedBadgeFragment } from '@/modules/gamification/components/BadgeGroupView';
import BadgePreviewModal from '@/modules/gamification/components/BadgeGroupView/BadgePreviewModal';

export type BadgePreviewType = Pick<
  UpdatedBadgeFragment,
  'name' | 'achievementRemark' | 'pointsConfig' | 'media' | 'id'
>;

const BadgePreviewModals = ({ badges }: { badges: BadgePreviewType[] }) => {
  const featureFlags = useFeatureFlags();
  const { [FeatureFlags.EnableGamification]: isGamificationEnabled } = featureFlags;

  const [currentBadge, setCurrentBadge] = useState<BadgePreviewType | undefined>(badges[0]);
  if (currentBadge === undefined) {
    return null;
  }

  const currentBadgeIndex = badges.findIndex((badge) => badge.id === currentBadge.id);

  const onNext = () => {
    if (currentBadgeIndex === badges.length - 1) {
      setCurrentBadge(undefined);
    } else {
      setCurrentBadge(badges[currentBadgeIndex + 1]);
    }
  };

  const onPrev = () => {
    if (currentBadgeIndex === 0) {
      setCurrentBadge(undefined);
    } else {
      setCurrentBadge(badges[currentBadgeIndex - 1]);
    }
  };

  if (!isGamificationEnabled) {
    return null;
  }

  return (
    <BadgePreviewModal
      badge={currentBadge}
      isPreview={false}
      open={currentBadge !== undefined}
      showNext={currentBadgeIndex !== badges.length - 1}
      showPrev={currentBadgeIndex !== 0 && badges.length > 1}
      onClose={() => setCurrentBadge(undefined)}
      onNext={onNext}
      onPrev={onPrev}
    />
  );
};

export default BadgePreviewModals;
